import PropTypes from 'prop-types';

function IFPetsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M8.96335 13.6252C8.96335 13.6252 7.16633 25.1775 7.71827 25.6481C8.27021 26.1188 12.8526 28.2752 21.474 26.3027C28.4268 24.7111 32.2732 22.0712 33.6381 19.8035C34.1901 19.1617 27.862 9.23535 27.862 9.23535L8.96335 13.6252Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M19.1397 14.6201C24.3514 13.4121 28.2459 11.0071 27.8382 9.24834C27.4306 7.48962 22.8752 7.04318 17.6635 8.25119C12.4518 9.45919 8.55738 11.8642 8.96503 13.6229C9.37268 15.3816 13.9281 15.8281 19.1397 14.6201Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.9088 18.9179C24.227 18.8443 24.5163 18.678 24.7401 18.4399C24.9638 18.2019 25.112 17.9029 25.1657 17.5807C25.2195 17.2585 25.1766 16.9276 25.0423 16.6298C24.908 16.332 24.6884 16.0807 24.4112 15.9078C24.1341 15.7348 23.8119 15.6479 23.4854 15.658C23.1589 15.6682 22.8428 15.7749 22.5769 15.9648C22.3111 16.1546 22.1075 16.419 21.992 16.7246C21.8764 17.0301 21.8541 17.3631 21.9278 17.6814C21.9487 17.7726 21.9788 17.8615 22.0176 17.9466L17.3111 19.0377C17.3046 18.9442 17.2918 18.8513 17.2726 18.7596C17.198 18.4504 17.0357 18.1693 16.8052 17.9501C16.5747 17.7309 16.2858 17.583 15.9733 17.524C15.6607 17.4651 15.3378 17.4976 15.0433 17.6178C14.7487 17.738 14.4952 17.9406 14.3131 18.2014C14.131 18.4622 14.0281 18.77 14.0167 19.0879C14.0053 19.4057 14.086 19.7201 14.2489 19.9933C14.4119 20.2664 14.6503 20.4867 14.9355 20.6276C15.2207 20.7685 15.5404 20.8241 15.8564 20.7876C15.5536 20.8906 15.2872 21.0793 15.0896 21.3308C14.8919 21.5823 14.7716 21.8858 14.7431 22.2043C14.7147 22.5229 14.7793 22.8429 14.9293 23.1255C15.0792 23.408 15.308 23.6409 15.5878 23.7959C15.8676 23.9509 16.1863 24.0213 16.5054 23.9986C16.8244 23.9759 17.13 23.861 17.385 23.668C17.64 23.4749 17.8335 23.2119 17.9419 22.911C18.0503 22.6101 18.069 22.2841 17.9957 21.9728C17.9743 21.8822 17.9457 21.7935 17.9102 21.7075L22.6166 20.6165C22.6234 20.7099 22.6363 20.8028 22.6551 20.8946C22.7287 21.2129 22.895 21.5022 23.1331 21.7259C23.3711 21.9496 23.6701 22.0978 23.9923 22.1516C24.3145 22.2054 24.6454 22.1624 24.9432 22.0281C25.241 21.8938 25.4923 21.6742 25.6653 21.3971C25.8382 21.1199 25.9251 20.7978 25.915 20.4713C25.9048 20.1447 25.7981 19.8286 25.6082 19.5627C25.4184 19.2969 25.154 19.0933 24.8484 18.9778C24.5429 18.8622 24.2099 18.8399 23.8917 18.9136L23.9088 18.9179Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.4292 15.2511C12.8314 14.4681 17.4266 10.1809 24.8372 12.3758C19.0054 15.6533 12.4292 15.2511 12.4292 15.2511Z"
                fill="#453D3D"
            />
        </svg>
    );
}

export default IFPetsInactive;

IFPetsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFPetsInactive.defaultProps = {
    className: null,
};
